import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import { randomSequentialId } from 'util/utils';

export default function Toggle({ options = [], handleToggleChange, className='', labelClassName='' }) {
    const [identifier] = useState(randomSequentialId());
    const handleToggleChanger = (e) => {
        const selVal = e?.target?.value;
        const pos = options.findIndex((x) => x.value === selVal);
        if(selVal) {
            handleToggleChange({pos, value: selVal});
        }
    }
    let defaultOp = options.filter(op => op.checked);
    if(!defaultOp?.length) defaultOp = options[0];

  return (
    <StyledToggle className={className}>
        <div className={`switch-field`}>
          {options.map((op, index) => (
            <Fragment key={String(index) + identifier}>
              <input
                type="radio"
                id={`radio-${index}`}
                name={identifier}
                value={op.value}
                defaultChecked={Boolean(op.checked)}
                onChange={handleToggleChanger}
              />
              <label htmlFor={`radio-${index}`} className={labelClassName} >{op.label}</label>
            </Fragment>
          ))}    
        </div>
    </StyledToggle>
  );
}

var StyledToggle = styled.div`
  .switch-field {
    display: flex;
    overflow: hidden;
  }

  .switch-field input {
    position: absolute !important;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    width: 1px;
    border: 0;
    overflow: hidden;
  }

  .switch-field label {
    background-color: #e4e4e4;
    color: rgba(0, 0, 0, 0.6);
    // font-size: 14px;
    line-height: 1;
    text-align: center;
    padding: 8px 16px;
    margin-right: -1px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3),
      0 1px rgba(255, 255, 255, 0.1);
    transition: all 0.1s ease-in-out;
  }

  .switch-field label:hover {
    cursor: pointer;
  }

  .switch-field input:checked + label {
    background-color: #a5dc86;
    box-shadow: none;
  }

  .switch-field label:first-of-type {
    border-radius: 4px 0 0 4px;
  }

  .switch-field label:last-of-type {
    border-radius: 0 4px 4px 0;
  }
`;